/**
 * Truncates a string in the middle with an ellipsis.
 */
export function truncateMiddle(str: string, maxLength: number): string {
  const separator = '...';
  if (str.length > maxLength) {
    const visibleChars = maxLength - separator.length;
    const firstChars = Math.ceil(visibleChars / 2);
    const lastChars = Math.floor(visibleChars / 2);
    return str.slice(0, firstChars) + separator + str.slice(str.length - lastChars);
  }
  return str;
}

const firstUpper = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
export const capitalize = (str: string) => firstUpper(str.toLowerCase());

export const sanitizeNumberInput = (value: string) =>
  value.replace(',', '.').replaceAll(' ', '').replaceAll('\xa0', '');
